import _ from 'lodash';

export const description =
  'A collection of projects, examples, and experiments using a broad range of QLab programming techniques including AppleScript, OSC, external control using QLab Remote, third-party MIDI and OSC controllers, and other software.';

const overrides: Record<string, string> = {
  osc: 'OSC',
  midi: 'MIDI',
  'hotkeys-and-triggers': 'Hotkeys and Triggers',
};

/**
 * Title cases the tag id with some specific overrides.
 */
export function tagName(tag: string): string {
  return overrides[tag] || _.startCase(tag);
}
